import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d137ce4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "amask" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "time" }

import * as filters from '@/views/filters';


export default /*#__PURE__*/_defineComponent({
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
    item: any
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: "article-item",
    style: _normalizeStyle(_unref(filters).bg(__props.item.thumb))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.item.title), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(filters).date2(__props.item.addtime || __props.item.createtime)), 1)
    ])
  ], 4))
}
}

})